import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteFinancialAccountTypeSaga,
  getFinancialAccountTypeDetailsSaga,
  getFinancialAccountTypeListSaga,
} from "src/store/financialaccount-types/saga";
import {
  FinancialAccountTypeDetailDto,
  FinancialAccountTypeDto,
} from "src/store/financialaccount-types/type";
import FinancialAccountTypeCreateForm from "./create";
import FinancialAccountTypeEditForm from "./edit";
const FinancialAccountTypePage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<FinancialAccountTypeDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<FinancialAccountTypeDetailDto>();
  const columns = [
    {
      text: t("FinancialAccountType.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("FinancialAccountType.PageTitle")}
        metaTag={t("FinancialAccountType.MetaTag")}
        gridProps={{
          addTitle: t("FinancialAccountType.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getFinancialAccountTypeListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getFinancialAccountTypeDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: FinancialAccountTypeDto) =>
              t("FinancialAccountType.DeleteQA", {
                name: data.Name,
              }),
            action: deleteFinancialAccountTypeSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <FinancialAccountTypeCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getFinancialAccountTypeListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <FinancialAccountTypeEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getFinancialAccountTypeListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default FinancialAccountTypePage;
